// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".queryFormClass[data-v-243160f6] {\n  height: calc(100vh - 136px);\n  padding: 15px;\n}\n.demo-drawer__footer[data-v-243160f6] {\n  text-align: right;\n  padding-right: 20px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  border-top: 1px solid #ccc;\n}", ""]);
// Exports
module.exports = exports;
